import { motion } from "framer-motion";

export default function SidebarLogo() {
  return (
    <div className="relative flex justify-center items-center h-20">
      {/* Subtle Sparkle Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="animate-sparkle absolute w-1.5 h-1.5 bg-white rounded-full top-1 left-2 opacity-60 blur-sm"></div>
        <div className="animate-sparkle animation-delay-2000 absolute w-1 h-1 bg-blue-300 rounded-full bottom-1 right-3 opacity-50 blur-sm"></div>
      </div>

      <motion.div
        whileHover={{ scale: 1.04 }}
        className="relative bg-gradient-to-r from-purple-600 to-indigo-600 px-2 py-2 rounded-xl shadow-lg hover:shadow-indigo-400/40 border border-white/10 transition-all duration-300 flex items-center space-x-2"
      >
        <img
          src="./Images/logos/google-adx-logo-1-1.png"
          className="h-10 w-auto object-contain drop-shadow-md"
          alt="Google AdX Logo"
        />
        <p className="text-white font-medium text-sm hidden lg:block">
         Google BidExchange
        </p>
      </motion.div>
    </div>
  );
}
